<header class="navbar navbar-fixed-top subnavbar bg-system">
    <ul class="nav navbar-nav navbar-left" ng-class="{ 'closed-main-menu' : collapseMenuStatus }">
        <div class="form-group floating">
            <input type="text" ng-model="filterData.location" class="btn btn-operation  text-input form-control"
                   placeholder="By Full Name" ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Full Name</label>
        </div>
        <!-- <div class="form-group floating ml10">
            <input type="text" ng-model="filterData.phone_number" class="btn btn-operation  text-input form-control"
                   placeholder="By Phone Number" ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Phone Number</label>
        </div>
        <div class="form-group floating ml10">
            <input type="text" ng-model="filterData.term" class="btn btn-operation text-input form-control"
                   placeholder="By Order ID" ng-keyup="$event.keyCode == 13 && refreshData()">
            <label>By Order ID</label>
        </div> -->
        <div class="form-group ml10 relative">
            <input type="text" 
                options="opts" 
                date-range-picker 
                ng-model="filterData.scheduled_time"
                class="form-control text-input btn"
                placeholder="By Delivery Date" 
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <label class="with-caret"></label>
        </div>
        <div class="form-group ml10">
            <select class="selectpicker"
                multiple
                title="By Status"
                data-selected-text-format="count"
                data-language="tr_TR"
                ng-model="filterData.workSteps"
                data-style="btn btn-primary" 
                ng-keyup="$event.keyCode == 13 && refreshData()">
                <option 
                    ng-repeat="item in data.steps" 
                    data-select-watcher 
                    data-last="{{$last}}" 
                    value="{{item.id}}"
                    class="color-{{item.value}}">
                    {{item.name}}
                </option>
            </select>
        </div>
        <div class="form-group">
            <a href="#"
               class="btn w50 p-2 ml10"
               ng-show="filterData.workSteps.length || filterData.scheduled_time.startDate || filterData.location || filterData.phone_number || filterData.term"
               ng-click="refreshData('map')">
                <i class="fa fa-refresh"></i>
            </a>
        </div>
        <div class="form-group"
             ng-show="filterData.workSteps.length || filterData.scheduled_time.startDate || filterData.location || filterData.phone_number || filterData.term">
            <a href="#" class="clear-filter ml-3" ng-click="clearFilter()">
                Clear Filter
            </a>
        </div>
        <!-- <div class="pull-left" ng-if="filterProp.indexOf('workers') !== -1">
            <select class="ml10 selectpicker" 
                multiple 
                title="Personel"
                data-live-search="true" 
                data-selected-text-format="count" 
                data-language="tr_TR"
                ng-model="filterData.workers"
                data-style="btn-primary">
                <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
            </select>
            <a href="#" ng-click="addFilterProps('workers')"><i class="fa fa-close"></i></a>
        </div> -->
        <div class="pull-left" ng-if="filterProp.indexOf('customers') !== -1">
            <ui-select ng-model="filterData.customers" title="Müşteri" class="ml10 operation-live-search"
                       style="width:200px" multiple>
                <ui-select-match placeholder="Müşteri Seçiniz...">{{ $item.customer_name }}</ui-select-match>
                <ui-select-choices refresh="searchCustomer($select,'')" refresh-delay="0"
                                   repeat="searchRes in searchRes">
                    <span ng-bind-html="searchRes.customer_name | highlight: $select.search"></span>
                </ui-select-choices>
            </ui-select>
            <a href="#" ng-click="addFilterProps('customers')"><i class="fa fa-close"></i></a>
        </div>
        <div class="pull-left" ng-if="filterProp.indexOf('workTypes') !== -1">
            <select class="ml10 selectpicker" multiple title="Kargo Türü" data-live-search="true"
                    data-selected-text-format="count" data-language="tr_TR" ng-model="filterData.workTypes"
                    data-style="btn-primary">
                <option ng-repeat="item in data.types" data-select-watcher data-last="{{$last}}" value="{{item.id}}">
                    {{item.name}}
                </option>
            </select>
            <a href="#" ng-click="addFilterProps('workTypes')"><i class="fa fa-close"></i></a>
        </div>
        <div class="pull-left" ng-if="filterProp.indexOf('city') !== -1">
            <input type="text" ng-model="filterData.city" class="btn btn-operation ml10 text-input"
                   placeholder="İl/İlçe">
            <a href="#" ng-click="addFilterProps('city')"><i class="fa fa-close"></i></a>
        </div>
        <div class="pull-left" ng-repeat="item in data.fields"
             ng-if="filterProp.indexOf(item.id) !== -1 && item.type != 'select'">
            <input type="text" ng-model="filterData.fields[item.id]" class="btn btn-operation ml10"
                   placeholder="{{ item.name }}">
            <a href="#" ng-click="addFilterProps(item.id)"><i class="fa fa-close"></i></a>
        </div>
        <div class="pull-left" ng-repeat="item in data.fields"
             ng-if="filterProp.indexOf(item.id) !== -1 && item.type == 'select'">
            <select ng-model="filterData.fields[item.id]" class="btn btn-operation ml10">
                <option value="">{{ item.name }} Seçiniz</option>
                <option value="{{ field }}" ng-repeat="field in stringToArray(item.value)">{{ field }}</option>
            </select>
            <a href="#" ng-click="addFilterProps(item.id)"><i class="fa fa-close"></i></a>
        </div>
        <!--<a href="#" class="btn btn-warning ml10" ng-click="refreshData('map')" style="line-height: 20px;">-->
        <!--<i class="fa fa-refresh"></i>-->
        <!--</a>-->
        <!--<a href="#" class="btn btn-operation ml5" ng-click="clearFilter()" style="line-height: 20px;">-->
        <!--<i class="fa fa-times"></i>-->
        <!--</a>-->
    </ul>
    <ul class="nav navbar-nav navbar-center">
    </ul>
    <div class="nav navbar-nav navbar-right">
        <a href="#" ng-click="exportCustomerExcel()" class="btn btn-operation btn-outline">
            Export Excel
        </a>
        <a href="#" ng-click="report()" class="btn btn-operation ml-2" ng-if="!isActive(['customer-reports'])">
            Report
        </a>
    </div>
</header>
